import { Dispatch, SetStateAction } from 'react';

import { Icon, Th } from '@chakra-ui/react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

import { SortDirection, StructuringFollowUpSortColumn } from '../../gql/generated/graphql';

type StructuringFollowUpTableHeaderBaseProps = {
  header: string;
  hideHeader?: boolean;
};

type StructuringFollowUpTableHeaderConditionalProps =
  | {
      canSort: boolean;
      columnName: StructuringFollowUpSortColumn;
      sortColumn: StructuringFollowUpSortColumn;
      setSortColumn: Dispatch<SetStateAction<StructuringFollowUpSortColumn>>;
      sortDirection: SortDirection;
      setSortDirection: Dispatch<SetStateAction<SortDirection>>;
    }
  | {
      canSort?: never;
      columnName?: never;
      sortColumn?: never;
      setSortColumn?: never;
      sortDirection?: never;
      setSortDirection?: never;
    };

type StructuringFollowUpTableHeaderProps = StructuringFollowUpTableHeaderBaseProps &
  StructuringFollowUpTableHeaderConditionalProps;

const StructuringFollowUpTableHeader = ({
  header,
  hideHeader = false,
  canSort,
  columnName,
  sortColumn,
  setSortColumn,
  sortDirection,
  setSortDirection,
}: StructuringFollowUpTableHeaderProps) => (
  <Th
    color="white"
    cursor={canSort ? 'pointer' : 'default'}
    onClick={() => {
      if (!canSort) {
        return;
      }

      if (sortColumn === columnName) {
        // Toggle sort direction
        setSortDirection(
          sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc,
        );
      } else {
        setSortColumn(columnName);
        setSortDirection(SortDirection.Asc);
      }
    }}
  >
    {hideHeader ? '' : header}
    {sortColumn === columnName && canSort && (
      <Icon as={sortDirection === SortDirection.Asc ? BiChevronUp : BiChevronDown} marginLeft={1} />
    )}
  </Th>
);

export default StructuringFollowUpTableHeader;
